import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';

import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const $pub = inject('$pub');
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    const refreshRoute = () => {
      $pub('reload-router-view');
    };
    const __returned__ = {
      $pub,
      settingsStore,
      theme,
      refreshRoute
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});